<template>
  <a
    class="colorBlack navLink u-full-width"
    :href="consignmentOrder.target_url"
  >
    <div
      v-if="consignmentOrder.image"
      class="dropdownLeadImageContainer"
    >
      <img v-lazy="consignmentOrder.image">
    </div>
    <div class="u-full-width">
      <div v-html="cardTitle" />
      <div
        class="u-pull-right"
        v-html="cardTag"
      />
    </div>
  </a>
</template>

<script>
import apiMixin from '@/mixins/apiMixin.js'

export default {
	name: 'ListCard',
	components: {
	},
	mixins: [apiMixin],
	props: [
		'co'
	],
	data () {
		return {}
	},
	computed: {
		consignmentOrder () {
			return this.co
		},
		cardTitle () {
			const date = new Date(this.consignmentOrder.auction_start_date)
			return `${this.consignmentOrder.auction_name}, ${date.toLocaleDateString(
				'en-US', {
					month: '2-digit',
					day: '2-digit',
					year: 'numeric'
				}).replace(/\//g, '-')}`
		},
		cardTag () {
			return `${this.consignmentOrder.inventory_count} items`
		}
	},
	methods: {}
}

</script>

<style scoped></style>
